<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1 pl-3 bg-form esep-blue-bg text-light font-weight-bold text-left"  role="tab">
        <!-- <b-button
            block
            v-b-toggle="'accordion-plan-' + plan.id"
            variant="primary"
            class="font-weight-bold text-left"
        > -->
          {{ (this.plan.license && this.plan.license.title) ? $t('progress.trainingPlanAs') + this.$t(`licensesEnums.`+this.plan.license.title) : "Εκπαιδευτικό Πλάνο" }}
        <!-- </b-button> -->
      </b-card-header>
      <ShortcutIcons :icons="this.plan.degrees" v-if="this.plan.degrees" @open-tab="openTab"> </ShortcutIcons>
      <b-collapse
          :id="'accordion-plan-' + plan.id"
          accordion="plan"
          role="tabpanel"
          v-model="isVisible"
      >
        <b-card-body>

          <b-row v-for="degree in plan.degrees" :key="degree.module.id">
            <degree-component :degree="degree" :visible="!degree.issueDate"/>
          </b-row>

        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import ShortcutIcons from './shortcutIcons.vue';
import DegreeComponent from './degreeComponent.vue';

  export default {
    name: "PlanComponent",
    props: {
        plan: {}
    },
    data() {
        return {
            isVisible: true,
        };
    },
    methods: {
      openTab(id) {
        this.$root.$emit('bv::toggle::collapse', `accordion-degree-${id}`);
      },
    },
    components: { ShortcutIcons, DegreeComponent },
    computed: {
    }
  }
</script>